import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment"
import { RNSAPI } from "../../api";
import { Utils } from "../../utils";
import '../dialog/dialog';

class DelegateDeadlineViewModel {
    oldDeadline = ko.observable(null);
    newSB = ko.observable("");

    parentVM: any;

    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    pickClerk = async () => {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Sachbearbeiter", ["Sachbearbeiter"], ["Sachbearbeiter"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => this.newSB(selectedObject()["Sachbearbeiter_ID"]));
        $('#delegatemodal').modal('show');
    };

    delegateDeadline = async () => {
        $(".form-group").each(function () { $(this).removeClass("has-error"); });
        if (!Utils.checkErrors(["newSB"], this, "", [Utils.checkString])) return;

        try {
            let result = await RNSAPI.delegateDeadline(this.oldDeadline(), this.newSB());
            if (result.Type === "DelegationSuccessful") {
                $('#delegateDeadline').modal('hide');
                this.parentVM.update();
            } else {
                alert("Fehler beim Delegieren der Frist.");
            }
        } catch (e) {
            console.log(e);
            alert("Fehler beim Delegieren: " + e.responseText);
        }
    };

    constructor(params: any) {
        if (params && params.deadline) {
            this.oldDeadline = params.deadline;
            this.parentVM = params.vm;
        }
    }
}

let html = fs.readFileSync(__dirname + '/delegate.html', 'utf8');

ko.components.register("delegate-deadline-view", {
    viewModel: DelegateDeadlineViewModel,
    template: html
});